import { forwardRef, memo } from 'react';
// Material UI imports
import Box, { type BoxProps } from '@mui/material/Box';
import Chip, { type ChipProps } from '@mui/material/Chip';
// Material Icon imports
import AddRounded from '@mui/icons-material/AddRounded';
// SCSS imports
import { plusChip } from './PlusChip.module.scss';

type PlusChipProps = {
  readonly sx?: BoxProps['sx'];
  readonly chipSx?: ChipProps['sx'];
};

const PlusChip = forwardRef<HTMLDivElement, PlusChipProps>(({
  sx,
  chipSx
}, ref) => (
  <Box m={1} sx={sx}>
    <Chip
        ref={ref}
        sx={chipSx}
        icon={(
          <Box
              pl={4.5}
              pr={2.5}
              display="flex"
              alignItems="center"
              className={plusChip}
          >
            <AddRounded fontSize="inherit"/>
          </Box>
        )}
    />
  </Box>
));

PlusChip.displayName = 'PlusChip';

export default memo(PlusChip);
